import { styled } from 'styled-components';
import { Col } from 'components/Base/Grid';

export const FirstCol = styled(Col)`
  width: 95px;
`;
export const SecondCol = styled(Col)`
  width: 140px;
`;
